/**
 * Shops API Service
 *
 * Shop-Links für Bände die der User nicht besitzt
 *
 * Endpoints:
 * GET /shops/bands/{band_id} - Shop-Links für Band
 * GET /shops/isbn/{isbn}     - Shop-Links per ISBN
 */

import { get } from '../client';

/**
 * Shop-Links für einen Band laden
 * Nur verfügbar wenn der User den Band NICHT besitzt
 *
 * @param {number} bandId - Band ID
 * @returns {Promise<{success: boolean, data?: ShopLink[], error?: object}>}
 *
 * Response Item:
 * {
 *   name: string,
 *   url: string
 * }
 *
 * Errors: 404 NOT_FOUND, 409 ALREADY_OWNED
 */
export const getShopsForBand = async (bandId) => {
  return get(`/shops/bands/${bandId}`);
};

/**
 * Shop-Links per ISBN laden (öffentlich, ohne Login)
 * @param {string} isbn - ISBN
 * @returns {Promise<{success: boolean, data?: ShopLink[], error?: object}>}
 */
export const getShopsForIsbn = async (isbn) => {
  return get(`/shops/isbn/${isbn}`);
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} ShopLink
 * @property {string} name - Shop Name
 * @property {string} url - Shop URL
 */
